import styled from "styled-components";

export const Container = styled.div`
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const TitleText = styled.div`
  font-family: "Helvetica";
  font-size: 20px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.darkGray2};

  @media only screen and (max-width: 768px) {
    font-size: 16px;
  }
`;
